// @flow

export const getLabel = (prefix: string, caption: ?string): ?string => {
    return prefix && caption ? `${prefix} ${caption}` : caption;
};
